import React from "react";

export const WalletIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-macaw-ui-candidate
  >
    <path
      d="M21 7.28V5.5C21 4.12 19.88 3 18.5 3H5.5C4.12 3 3 4.12 3 5.5v13C3 19.88 4.12 21 5.5 21h13c1.38 0 2.5-1.12 2.5-2.5v-1.78c.61-.55 1-1.34 1-2.22v-5c0-.88-.39-1.67-1-2.22ZM5 5h13.5c.28 0 .5.22.5.5v1.5H5.5C4.67 7 4 6.33 4 5.5S4.67 5 5 5Zm15 9.5c0 .28-.22.5-.5.5H16c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h3.5c.28 0 .5.22.5.5v2Zm-3.5-.5h2v-1h-2v1Z"
      fill="currentColor"
    />
  </svg>
);
